export default function simpleActionCreator(type, reducer, ...argNames) {
  return function impl(...args) {
    const action = { type, reducer, state: {} };
    argNames.forEach((arg, index) => {
      action.state[argNames[index]] = args[index];
    });
    return action;
  };
}
